<template>
    <Modal :visible="showConfirm" :title="title" :className="className" :mask="mask" :showFooter="showFooter" :showHead="showHead" :closeAble="closeAble" :prefixCls="prefixCls" :zIndex="zIndex" :maskCloseAble="maskCloseAble">
        <div v-html="contentHtml" />
        <div :class="[prefixCls + '-footer-content']" slot="footer">
            <a href="javascript:void(0)" :class="[prefixCls + '-btn-cancel']" v-if="showCancel" @click.stop="cancelFn">{{cancelText}}</a>
            <a href="javascript:void(0)" :class="[prefixCls + '-btn-confirm']" @click.stop="okFn">{{okText}}</a>
        </div>
    </Modal>
</template>

<script>
    import Modal from "./Modal";
    export default {
        name: "Confirm",
        components:{
            Modal
        },
        data(){
            return{
                showConfirm: false,
                contentHtml:""
            }
        },
        props:{
            visible: {
                type: Boolean,
                default: false
            },
            prefixCls: {
                type: String,
                default: "tm-modal"
            },
            closeAble: {
                type: Boolean,
                default: true
            },
            maskCloseAble: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: "标题"
            },
            width: {
                type: [Number, String],
                default: 280
            },
            okText: {
                type: String,
                default: "确定"
            },
            cancelText: {
                type: String,
                default: "取消"
            },
            className: {
                type: String
            },
            // for instance
            showHead: {
                type: Boolean,
                default: true
            },
            showFooter: {
                type: Boolean,
                default: true
            },
            mask: {
                type: Boolean,
                default: true
            },
            zIndex: {
                type: Number,
                default: 1000
            },
            cancel:{
                type:Function,
                default: function() {

                }
            },
            ok:{
                type:Function,
                default: function() {

                }
            },
            content: {
                type: String,
                default: "我是confirm内容"
            },
            showCancel: {
                type: Boolean,
                default: true
            },
        },
        computed:{
            maskClasses () {
                const prefixCls = this.prefixCls;
                return `${prefixCls}-mask`;
            },
            showMask (){
                return this.mask;
            },
            contentClasses () {
                const prefixCls = this.prefixCls;
                return [
                    `${prefixCls}-content`,
                    {
                        [`${prefixCls}-content-no-mask`]: !this.showMask,
                    }
                ];
            },
            wrapClasses (){
                const prefixCls = this.prefixCls;
                return [prefixCls + '-wrapper',
                    {
                        [`${this.className}`]: !!this.className
                    }
                ]
            },
            wrapStyles () {
                return {
                    zIndex: this.zIndex
                };
            },
            maskWrapStyles(){
                return {
                    zIndex: this.zIndex + 1
                };
            },
            contentWrapStyles(){
                return {
                    zIndex: this.zIndex + 100
                };
            },
            cancelFn(){
                return this.cancel.bind(this, ...arguments);
            },
            okFn(){
                return this.ok.bind(this, ...arguments);
            }
        },
        beforeMount() {
            this.showConfirm = this.visible;
            this.contentHtml = this.content;
        },
        methods:{
            setContent(content){
                this.contentHtml = content;
                return this;
            },
            show(){
                this.showConfirm = true;
                return this;
            },
            close(){
                this.showConfirm = false;
                return this;
            }
        }
    };
</script>

<style lang="less">

</style>
